export const DEFAULT_ORDER = {
  direction: "desc",
  name: ["custom_values.created_at"],
  text: "Date created (newest first)"
};
